import axios from 'axios'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'

// Inject the Rails CSRF token into every Inertia request (axios is Inertia's
// internal HTTP client). Without this, Rails' protect_from_forgery raises
// ActionController::InvalidAuthenticityToken on every form.post() call.
const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
}

createInertiaApp({
  resolve: (name: string) => {
    const pages = import.meta.glob<{ default: React.ComponentType }>('../pages/**/*.tsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) throw new Error(`Inertia page not found: ${name}`)
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
  title: (title) => (title ? `${title} | Arianna Platform` : 'Arianna Platform'),
})
